import { types } from "../types";
const initialState = {
  students: [],
  studentById: null,
  studentToUpdate: null,
  studentToDelete: null,
  studentName: null,
};

export const studentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getStudent:
      return {
        ...state,
        students: action.payload,
      };

    case types.getStudentById:
      return {
        ...state,
        studentById: action.payload,
      };
    case types.createStudent:
      return {
        ...state,
        students: [action.payload, ...state.students],
      };
    case types.updateStudent:
      return {
        ...state,
        students: state.students.map((student) =>
          student._id === action.payload._id ? action.payload : student
        ),
      };

    case types.deleteStudent:
      return {
        ...state,
        students: state.students.filter(
          (student) => student._id !== action.payload
        ),
      };

    case types.setStudentToUpdate:
      return {
        ...state,
        studentToUpdate: action.payload,
      };

    case types.removeStudentFromUpdate:
      return {
        ...state,
        studentToUpdate: null,
      };

    case types.setStudentToDelete:
      return {
        ...state,
        studentToDelete: action.payload,
        studentName: state.students.filter((student) =>
          student._id === action.payload ? student : null
        ),
      };
    case types.removeStudentFromDelete:
      return {
        ...state,
        studentToDelete: null,
        studentName: null,
      };
    case types.removeStudentById:
      return {
        ...state,
        studentById: null,
      };
    default:
      return state;
  }
};
